import React from 'react';

// Client-side CSV/JSON export of already-fetched rows. (The backend also exposes
// GET /support/export/:dataset for full-history server-side exports.)

function toCSV(rows) {
  if (!rows || !rows.length) return '';
  const cols = [...new Set(rows.flatMap(r => Object.keys(r)))];
  const esc = v => {
    if (v == null) return '';
    const s = typeof v === 'object' ? JSON.stringify(v) : String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  return [cols.join(','), ...rows.map(r => cols.map(c => esc(r[c])).join(','))].join('\n');
}

function download(filename, text, type) {
  const blob = new Blob([text], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}

const ExportButton = ({ rows, name = 'export' }) => {
  const disabled = !rows || !rows.length;
  return (
    <div className="sp-export">
      <button className="sp-btn" disabled={disabled} onClick={() => download(`${name}.csv`, toCSV(rows), 'text/csv')}>Export CSV</button>
      <button className="sp-btn" disabled={disabled} onClick={() => download(`${name}.json`, JSON.stringify(rows, null, 2), 'application/json')}>Export JSON</button>
    </div>
  );
};

export default ExportButton;
